/**
 * children-api.js
 * Handles fetching children data from the Sunnymeal API
 * and populating label dropdowns on the checkout page.
 */

const SunnymealChildrenAPI = (function () {
    const BASE_URL = "https://sunny-meal-apps.devbdd.com/api";

    /**
     * Fetch children data by customer ID.
     * @param {string|number} customerId
     * @returns {Promise<Array<{id: number, name: string, birthday: string}>>} Array of children objects
     */
    async function getChildrenByCustomer(customerId) {
        if (!customerId) {
            console.warn("[children-api] customerId is required.");
            return [];
        }

        try {
            const response = await fetch(`${BASE_URL}/data-children/${customerId}`);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: Failed to fetch children data`);
            }
            const data = await response.json();
            return Array.isArray(data) ? data : [];
        } catch (error) {
            console.error("[children-api] Error fetching children:", error);
            return [];
        }
    }

    /**
     * Build <option> tags from children array.
     * @param {Array<{id: number, name: string}>} children - Array of child objects
     * @returns {string} HTML string of <option> elements
     */
    function buildOptions(children) {
        if (!children || children.length === 0) {
            return `<option value="" disabled>No children data</option>`;
        }

        const placeholder = `<option value="" disabled selected>-- Choose --</option>`;
        const options = children
            .map((child) => `<option value="${child.id}">${child.name}</option>`)
            .join("");

        return placeholder + options;
    }

    /**
     * Populate all .label-dropdown elements on the page with children options.
     * @param {string|number} customerId
     */
    async function populateLabelDropdowns(customerId) {
        const dropdowns = document.querySelectorAll(".label-dropdown");
        if (!dropdowns.length) return;

        const children = await getChildrenByCustomer(customerId);
        const optionsHtml = buildOptions(children);

        dropdowns.forEach(function (el) {
            const select = /** @type {HTMLSelectElement} */ (el);
            const currentVal = select.value;
            select.innerHTML = optionsHtml;
            if (currentVal) select.value = currentVal;
        });
    }

    return {
        getChildrenByCustomer,
        buildOptions,
        populateLabelDropdowns,
    };
})();
